import { isArray } from "lodash";
import { GenericDataParameters } from "../../../../../Components/Tables/_Tables/useColumnConstructor";

export function tableToRowMapper(row: {[key: string]: any}, accessor: string): string {
  if (typeof row[accessor] === "object" && (row[accessor] as JSX.Element)?.props) {
    if(row[accessor].props["progressed"] !== undefined && row[accessor].props["total"] !== undefined ) {
      return `${row[accessor].props["progressed"]} / ${row[accessor].props["total"]}`
    }
    if (row[accessor].props['content'] && typeof row[accessor].props.content === "string" && row[accessor].props.content !== undefined) {
      return row[accessor].props.content
    }

    return "";
  }

  if (typeof row[accessor] === "object" && row[accessor] && ("label" in row[accessor]) && row[accessor].label !== undefined) {
    return row[accessor].label;
  }
  return row[accessor] ?? ""  
}

export function headerToStringHeader(header: string | JSX.Element): string {
  if (typeof header === "object") {
    if ((header as JSX.Element).type === 'div' && typeof header.props === "object" && "children" in header.props && header.props.children !== undefined) {
      const firstChild = isArray(header.props.children) ? header.props.children[0] : header.props.children;
      if (typeof firstChild === "string") {
        return firstChild;
      }
      if ((firstChild as JSX.Element).type === "div" && typeof firstChild.props === "object" && "children" in firstChild.props && firstChild.props.children !== undefined && typeof firstChild.props.children === "string") {
        return firstChild.props.children;
      }
    }
  }
  return header.toString()
}

export const exportTableToCsv = <T,> (data: { [key: string]: any }[], filename: string, accessorData: GenericDataParameters<T>[]) => {
  if (!data.length) return;

  const headers = accessorData.map((col) => (headerToStringHeader(col.headerValue)));
  const rows = data.map((row) => accessorData.map((col) => tableToRowMapper(row, col.accessor)));
  const csvContent = "data:text/csv;charset=utf-8," + [headers.join(","), ...rows.map((row) => row.join(","))].join("\n");

  const encodedUri = encodeURI(csvContent);
  const link = document.createElement("a");
  link.setAttribute("href", encodedUri);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}